/**
 * Filter Matching Utilities
 * 
 * Functions for checking if tasks match view filter criteria.
 */

/**
 * Check if a task matches the view's filters
 * @param {Object} task - The task to check
 * @param {Object} filters - The view's filter criteria
 * @param {Object[]} statuses - The campaign's status definitions
 * @returns {boolean} Whether the task passes all filters
 */
export function taskMatchesFilters(task, filters, statuses = []) {
  if (!filters || Object.keys(filters).length === 0) {
    return true;
  }

  // Status category filter
  if (filters.statusCategories && filters.statusCategories.length > 0) {
    const taskStatus = statuses.find(s => s.id === task.status);
    const statusCategory = taskStatus?.category || 'not_started';
    if (!filters.statusCategories.includes(statusCategory)) {
      return false;
    }
  }

  // Specific status IDs filter
  if (filters.statusIds && filters.statusIds.length > 0) {
    if (!filters.statusIds.includes(task.status)) {
      return false;
    }
  }

  // Priority filter
  if (filters.priority) {
    if (task.priority !== filters.priority) {
      return false;
    }
  }

  // Category filter
  if (filters.categoryIds && filters.categoryIds.length > 0) {
    if (!filters.categoryIds.includes(task.category)) {
      return false;
    }
  }

  // Has deliverables filter
  if (filters.hasDeliverables) {
    const hasDeliverables = task.deliverables && task.deliverables.length > 0;
    if (!hasDeliverables) {
      return false;
    }
  }

  // Has due date filter
  if (filters.hasDueDate) {
    if (!task.dueDate) {
      return false;
    }
  }

  // Is overdue filter
  if (filters.isOverdue) {
    if (!task.dueDate) {
      return false;
    }
    const now = new Date();
    const dueDate = new Date(task.dueDate);
    const isOverdue = dueDate < now && task.status !== 'completed';
    if (!isOverdue) {
      return false;
    }
  }

  return true;
}
